import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { ATL_PAGE_CONTENT_FOOTER_ACTIONS } from '@confluence/web-item-location/entry-points/webFragmentLocations';
import { WebPanelLocationQuery } from '@confluence/web-panel-location/entry-points/WebPanelLocationQuery';
import { usePathnameMatcher } from '@confluence/route-manager/entry-points/RouteState';

export const useIsReactionsEnabled = (contentId: string) => {
	const isPDFExport = usePathnameMatcher({
		selector: (pathname) => pathname?.indexOf('/wiki/pdf/') !== -1,
	});

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		WebPanelLocationQuery,
		{
			variables: {
				contentId,
				location: ATL_PAGE_CONTENT_FOOTER_ACTIONS,
			},
			fetchPolicy: 'cache-first',
			skip: isPDFExport,
		},
	);

	return !isPDFExport && data && data.webPanels && data.webPanels.length > 0;
};
